import { useCssModule, ref, computed, onMounted } from "vue";
import "./assets/index-CgZzOVq6.js";
import "vue-demi";
import { u as useDataTestIdProp } from "./assets/index-BNd8MWnO.js";
import "./assets/index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "vue-i18n";
import "./locales.js";
const xEllipsis = "_xEllipsis_1l0eh_1";
const off = "_off_1l0eh_1";
const oneLine = "_oneLine_1l0eh_5";
const style0 = {
  xEllipsis,
  off,
  oneLine
};
const { createTestIdProp, setupTestId } = useDataTestIdProp();
const __default__ = {
  name: "XEllipsis"
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    visibleLines: {
      type: Number,
      default: 1
    },
    maxLength: {
      type: Number,
      default: 0
    },
    ...createTestIdProp()
  },
  setup(__props) {
    const props = __props;
    const { formatTestId } = setupTestId(props);
    const $style = useCssModule();
    const refContent = ref(null);
    const originalText = ref("");
    function truncateText(text) {
      return text.substring(0, props.maxLength);
    }
    const customStyles = computed(() => {
      if (!props.maxLength) {
        return {
          webkitLineClamp: props.visibleLines
        };
      }
      return {};
    });
    const customClass = computed(() => ({
      [$style.off]: !!props.maxLength || !props.visibleLines,
      [$style.oneLine]: props.visibleLines === 1
    }));
    const truncatedText = computed(() => {
      var _a;
      if (props.maxLength && refContent.value) {
        return `${truncateText((_a = refContent.value) == null ? void 0 : _a.textContent)}...`;
      }
      return null;
    });
    function hasValidText() {
      var _a;
      return (_a = refContent.value) == null ? void 0 : _a.textContent.replace(/\s+/g, "");
    }
    function setOriginalText() {
      originalText.value = refContent.value.textContent;
    }
    onMounted(() => {
      if (hasValidText()) {
        setOriginalText();
      }
    });
    return { __sfc: true, createTestIdProp, setupTestId, props, formatTestId, $style, refContent, originalText, truncateText, customStyles, customClass, truncatedText, hasValidText, setOriginalText };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { ref: "refContent", class: [_setup.$style.xEllipsis, _setup.customClass], style: _setup.customStyles, attrs: { "data-testid": _setup.formatTestId(), "title": _setup.originalText } }, [_setup.truncatedText ? _c("span", { attrs: { "aria-description": _setup.originalText, "data-testid": _setup.formatTestId("truncatedContainer") } }, [_c("span", { attrs: { "aria-hidden": "true", "data-testid": _setup.formatTestId("truncatedText") } }, [_vm._v(_vm._s(_setup.truncatedText))])]) : _vm._t("default")], 2);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const XEllipsis = __component__.exports;
export {
  XEllipsis as default
};
